import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Card, CardContent, Grid, Modal, Typography } from '@mui/material';
import LoadingButtonGeneral from '../../../components/general/buttons/loadingButtonGeneral';

type Props = {
    open: boolean;
    filingNumber: string;
    onNewRequest: () => void;
    onRefreshPage: () => void;
};

export const OrbitRadicationSuccessDialog = ({
    open,
    filingNumber,
    onNewRequest,
    onRefreshPage,
}: Props) => (
    <Modal
        open={open}
        aria-labelledby="orbit-radication-success-title"
        aria-describedby="orbit-radication-success-description"
    >
        <Box
            className="modal-card-container"
            sx={{
                width: { xs: '92%', sm: 480 },
                maxWidth: 520,
            }}
        >
            <Card className="modal-card">
                <CardContent sx={{ textAlign: 'center', py: 3 }}>
                    <Grid
                        container
                        spacing={2}
                        direction="column"
                        alignItems="center"
                    >
                        <Grid item>
                            <CheckCircleIcon
                                sx={{
                                    fontSize: 48,
                                    color: 'primary.main',
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography
                                id="orbit-radication-success-title"
                                component="h2"
                                sx={{
                                    fontSize: { xs: 23, lg: 27 },
                                    fontWeight: 700,
                                    color: 'primary.main',
                                    textAlign: 'center',
                                    lineHeight: 1.2,
                                }}
                            >
                                ¡Solicitud Radicada!
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sx={{ width: '100%' }}>
                            <Box
                                sx={{
                                    border: '1px solid',
                                    borderColor: 'primary.main',
                                    borderRadius: 1,
                                    bgcolor: 'grey.50',
                                    py: 2,
                                    px: 2,
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: '#000',
                                        mb: 0.5,
                                    }}
                                >
                                    Número de radicado Orbit:
                                </Typography>
                                <Typography
                                    sx={{
                                        fontWeight: 'bold',
                                        fontSize: { xs: 24, sm: 28 },
                                        color: 'primary.main',
                                        wordBreak: 'break-word',
                                    }}
                                >
                                    {filingNumber}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography
                                id="orbit-radication-success-description"
                                variant="body2"
                                className="modal-card-content"
                                sx={{ mb: 0, textAlign: 'center' }}
                            >
                                Guarde este número para consultar el estado de
                                su solicitud.
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sx={{ width: '100%' }}>
                            <LoadingButtonGeneral
                                fullWidth
                                title="Radicar nueva solicitud"
                                onClick={onNewRequest}
                                sx={{ mb: 1.5 }}
                            />
                            <LoadingButtonGeneral
                                fullWidth
                                title="Actualizar página"
                                variant="outlined"
                                onClick={onRefreshPage}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography
                                variant="caption"
                                sx={{ color: 'text.secondary' }}
                            >
                                Si necesita registrar otra PQR, use
                                &apos;Radicar nueva solicitud&apos;.
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    </Modal>
);
